import React, { useEffect, useState } from 'react';
import { v2_projects, v2_ships } from '../../../actions/v2/projectAndVessel';
import { v2_schedule_categories, v2_event_type } from '../../../actions/v2/masterData';
import Select from 'react-select';

const SearchBar = ({ onSearch }) => {
    const [searchState, setSearchState] = useState({
        project: { name: 'project', value: '', options: [] },
        hull: { name: 'hull', value: '', options: [] },
        category: { name: 'category', value: '', options: [] },
        eventType: { name: 'eventType', value: [], options: [] },
    });
    const handleMultiSelectChange = (selectedOptions) => {
        setSearchState((prev) => ({
            ...prev,
            eventType: {
                ...prev.eventType,
                value: selectedOptions || [],
            },
        }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setSearchState((prev) => ({
            ...prev,
            [name]: {
                ...prev[name],
                value,
            },
        }));
    };

    const handleReset = () => {
        setSearchState((prev) => {
            const resetState = { ...prev };
            for (const key in resetState) {
                resetState[key].value = '';
            }
            return resetState;
        });
    };

    const handleSubmit = () => {
        // e.preventDefault();
        // Implement search logic here using searchState values
        onSearch(btoa(JSON.stringify({
            projectId: searchState.project.value,
            shipId: searchState.hull.value,
            categoryId: searchState.category.value,
            eventType: searchState.eventType.value.map((item) => item.value)

        })))
    };

    useEffect(() => {
        v2_projects().then((res) => {
            if (res.status) {
                setSearchState((prev) => ({
                    ...prev,
                    project: { ...prev.project, options: res.result },
                }));
            }
        });

        v2_schedule_categories().then((res) => {
            if (res.status) {
                setSearchState((prev) => ({
                    ...prev,
                    category: { ...prev.category, options: res.result },
                }));
            }
        });
    }, []);

    useEffect(() => {
        v2_ships(null, searchState.project.value).then((res) => {
            if (res.status) {
                setSearchState((prev) => ({
                    ...prev,
                    hull: { ...prev.hull, options: res.result },
                }));
            }
        });

    }, [searchState.project.value]);

    useEffect(() => {
        handleSubmit()
    }, [searchState.project.value, searchState.category.value, searchState.hull.value, searchState.eventType.value])

    useEffect(() => {
        v2_event_type(searchState.category.value).then((res) => {
            if (res.status) {
                setSearchState((prev) => ({
                    ...prev,
                    eventType: {
                        ...prev.eventType,
                        options: res.result.map((item) => ({
                            label: item.EVENT_TYPE_NAME,
                            value: item.ID
                        })),
                        value: [],
                    },
                }));
            }
        });
    }, [searchState.category.value]);

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card cardSearchBox">
                    <div className="card-body card-body-search">
                        <form className="row gy-12 gx-12 align-items-center" >
                            <div className="row">
                                <div className="form-group col-md-3">
                                    {/* <label>Projects</label> */}
                                    <select
                                        className="form-control"
                                        name="project"
                                        value={searchState.project.value}
                                        onChange={handleChange}
                                    >
                                        <option value="">All Projects</option>
                                        {searchState.project.options.map((item) => (
                                            <option key={item.ID} value={item.ID}>
                                                {item.PROJECT_CODE} - {item.PROJECT_NAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-3">
                                    {/* <label>Hulls</label> */}
                                    <select
                                        className="form-control"
                                        name="hull"
                                        value={searchState.hull.value}
                                        onChange={handleChange}
                                    >
                                        <option value="">All Hulls</option>
                                        {searchState.hull.options.map((item) => (
                                            <option key={item.ID} value={item.ID}>
                                                {item.HULL_NUMBER} - {item.SHIP_NAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-2">
                                    {/* <label>Category</label> */}
                                    <select
                                        className="form-control"
                                        name="category"
                                        value={searchState.category.value}
                                        onChange={handleChange}
                                    >
                                        <option value="">All Categories</option>
                                        {searchState.category.options.map((item) => (
                                            <option key={item.ID} value={item.ID}>
                                                {item.CATEGORY_NAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-4">
                                    {/* <label>Events</label> */}
                                    <Select
                                        isMulti
                                        name="eventType"
                                        value={searchState.eventType.value}
                                        options={searchState.eventType.options}
                                        onChange={handleMultiSelectChange}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="All Events"
                                    />
                                </div>
                            </div>
                            {/* <div className="row mt-3">
                                <div className="form-group col-md-12">
                                    <button
                                        type="submit"
                                        className="btn btn-info"
                                        style={{ backgroundImage: "linear-gradient(90deg, #6895b4, #265578)" }}
                                    >
                                        <i className="bx bx-check-double label-icon" /> Search
                                    </button>
                                    &nbsp;&nbsp;
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger"
                                        onClick={handleReset}
                                    >
                                        Reset
                                    </button>
                                    &nbsp;&nbsp;
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        style={{ backgroundImage: "linear-gradient(90deg, #6895b4, #265578)" }}
                                        onClick={() => {
                                            console.log("Download All Records clicked");
                                        }}
                                    >
                                        <i className="bx bx-cloud-download label-icon" /> Download All Records
                                    </button>
                                </div>
                            </div> */}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchBar;
